// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import { createContext, useContext, useState } from "react"

const AlertModalContext = createContext(undefined)

interface AlertModal {
  title: string
  text: React.ReactNode
  actions?: React.ReactNode[]
}

export const AlertModalProvider = ({ children }) => {
  const [alertModals, setAlertModals] = useState([])

  const pushAlertModal = (modal: AlertModal) => {
    setAlertModals((prev) => [...prev, modal])
  }

  const shiftAlertModal = () => {
    setAlertModals((prev) => prev.slice(1))
  }

  return (
    <AlertModalContext.Provider
      value={{
        alertModals,
        pushAlertModal,
        shiftAlertModal,
      }}
    >
      {children}
    </AlertModalContext.Provider>
  )
}

export const useAlertModal = () => {
  const context = useContext(AlertModalContext)
  if (!context) {
    throw new Error("useAlertModal must be used within an AlertModalProvider")
  }
  return context
}
